import React from 'react'

import {SearchIcon} from 'components/CustomIcons'

const SuggestionItem = ({title, searchValue, onClick}) => (
  <button className='searchMainSuggestions' onClick={onClick}>
    <span className='searchMainSuggestions-text'>
      {title.indexOf(searchValue) > -1 ? (
        <>{title.split(searchValue)[0]}<b>{searchValue}</b>{title.split(searchValue)[1]}</>
      ) : (
        title
      )}
    </span> <SearchIcon/>
  </button>
)

const Suggestions = ({t, suggestions, handleSearch, searchValue}) => (
  <div className='productsList-suggestions'>
    <h4>{t('Suggestions for')} <b>"{searchValue}"</b></h4>
    <div>
      <div>
        {suggestions?.map(e => (
          <SuggestionItem
            key={e.highlight}
            onClick={_ => handleSearch(e.highlight)}
            title={e.highlight}
            searchValue={searchValue}
          />
        ))}
      </div>
    </div>
  </div>
)

export default Suggestions
